import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import QRScanner from '../components/QRScanner';
import { eventsApi, zonesApi, checkinApi, parseScan, routeScan } from '../api';

export default function RemoteCheckin() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('menu'); // menu | scan
  const [events, setEvents] = useState([]);
  const [zones, setZones] = useState([]);
  const [eventId, setEventId] = useState('');
  const [zoneId, setZoneId] = useState('');
  const [active, setActive] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    eventsApi.list().then((r) => setEvents(r.data.filter((e) => e.active))).catch(() => {});
    checkinApi.active().then((r) => setActive(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setZoneId('');
    if (!eventId) { setZones([]); return; }
    zonesApi.list(eventId).then((r) => setZones(r.data)).catch(() => setZones([]));
  }, [eventId]);

  const handleScan = (text) => {
    const parsed = parseScan(text);
    if (!routeScan(parsed, navigate)) { setError('QR kód se nepodařilo přečíst.'); setMode('menu'); }
  };

  const proceed = () => {
    if (!eventId || !zoneId) return;
    navigate(`/checkin?event=${eventId}&zone=${zoneId}`);
  };

  return (
    <div>
      <AppHeader subtitle="Příchody / odchody" />
      <div className="container" style={{ paddingTop: 24 }}>

        {active.length > 0 && (
          <div className="card mb-16" style={{ borderLeft: '4px solid var(--green)' }}>
            <h3 className="mb-8">Aktuálně přihlášeni</h3>
            {active.map((a) => (
              <div key={a.zone_id} style={{ fontSize: '0.9rem', marginBottom: 4 }}>
                📍 <strong>{a.zone_name}</strong> <span className="text-muted">({a.event_name})</span>
              </div>
            ))}
          </div>
        )}

        {mode === 'scan' ? (
          <div className="card">
            <h3 className="mb-16">Naskenovat QR kód</h3>
            <QRScanner onScan={handleScan} onClose={() => setMode('menu')} />
          </div>
        ) : (
          <>
            <div className="card mb-16 text-center">
              <div style={{ fontSize: 48, marginBottom: 8 }}>📷</div>
              <p className="text-muted mb-16">Naskenujte QR kód u vchodu do zóny.</p>
              <button className="btn btn-primary btn-full" onClick={() => { setError(''); setMode('scan'); }}>
                Spustit skener
              </button>
            </div>

            <div className="card">
              <h3 className="mb-8">Vzdálený výběr</h3>
              <p className="text-muted mb-16" style={{ fontSize: '0.85rem' }}>
                Když je QR kód v místě bez signálu, vyberte MU a zónu ručně odsud.
              </p>
              <div className="form-group">
                <label>Mimořádná událost</label>
                <select className="form-input" value={eventId} onChange={(e) => setEventId(e.target.value)}>
                  <option value="">— vyberte MU —</option>
                  {events.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Zóna</label>
                <select className="form-input" value={zoneId} onChange={(e) => setZoneId(e.target.value)} disabled={!eventId}>
                  <option value="">— vyberte zónu —</option>
                  {zones.map((z) => <option key={z.id} value={z.id}>{z.name}</option>)}
                </select>
              </div>
              {error && <div className="alert alert-warning mb-16">{error}</div>}
              <button className="btn btn-success btn-full" onClick={proceed} disabled={!eventId || !zoneId}>
                Pokračovat
              </button>
              {eventId && (
                <button className="btn btn-outline btn-full mt-8" onClick={() => navigate(`/mu/${eventId}/mapa`)}>
                  🗺️ Zobrazit mapu této MU
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
